import React, {memo, useRef, useState} from "react";
import ChatDivide from "../../assets/img/subject_underline_shine_effect.png";
import ThumbIcon from "../../assets/img/common/emojis/hand_1.png"
import {awardWinnersRef, firestore} from "../../config/firebaseConfig";
import {useCollectionData} from "react-firebase-hooks/firestore";
import DefaultAvatar from '../../assets/img/ballroom/awardPanel/default_avatar.jpeg'
import {getCurrentUser} from "../../pages/root/helpers";



const awardWinner = {
  firstname: 'First Name',
  lastname: 'Last Name',
  company: 'Company',
  bio: 'Rodney Erickson is a content marketing professional at HubSpot, an inbound marketing and sales platform that helps companies attract visitors, convert leads, and close customers. Previously, Rodney worked as a marketing manager for a tech software startup. He graduated with honors from Columbia University with a dual degree in Business Administration and Creative Writing.',
}

const AwardPanel = ({height, winner}) => {
  
  //
  // const [fontSize, setFontSize] = React.useState(window.innerWidth> 900? 36: window.innerWidth * 0.02);
  //
  // React.useEffect(() => {
  //   function handleResize() {
  //     if (window.innerWidth > 900)
  //     {
  //       setFontSize(window.innerWidth * 0.02)
  //     }
  //     else {
  //       setFontSize(window.innerWidth * 0.01)
  //     }
  //   }
  //   window.addEventListener('resize', handleResize)
  // }, []);


  return(
    <div className="coverup" style={{width: '100%', height: '100%'}}>
      <div style={{fontSize: '1.1vw', padding: '0.5vw 1.2vw'}}>
        <span className="pull-left" >Award Winner</span>
      </div>
      <img src={ChatDivide} alt="ChatHeader" style={{width: '100%', height: 10, marginTop: -23}}/>
      <div className='award-winner-info'>
        {/*<img src={DefaultAvatar}  style={{margin: '1.1vw', height: 'auto', width: '5.1vw'}} alt={ ''} className={'avatar'} />*/}
        <div className={'winner-info'}  style={{padding: '0 20px'}}>
          <h3 style={{margin: '1.1vw 0 0 0 ', fontSize: '0.9vw', textAlign: 'left', textTransform: 'uppercase'}}>{winner.nomination}</h3>
          <p style={{margin: 0, fontSize: '1.1vw', textAlign: 'left'}}>{winner.firstName + ' '+ winner.lastName}</p>
          <p style={{margin: 0, fontSize: '1.1vw', textAlign: 'left'}}>{winner.position}</p>
          <p style={{margin: 0, textAlign: 'left' ,fontSize: '1.1vw'}}>{winner.company}</p>
        </div>
      </div>
      <div style={{padding: '0px 1.2vw',overflowX: 'hidden', maxHeight: height}} className={'custom-scrollbar'}>
        <p style={{fontSize: '1.0vw', textAlign:'left',}}>{winner.text}</p>
      </div>
    </div>
  )
}

export default memo(AwardPanel);